import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { BusinessFiltersDto } from '@/generated/Messages/Filters_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import {
    businessesQueryKeyPrefix,
    listQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

export const usersListQueryKeyPrefix = [
    businessesQueryKeyPrefix,
    listQueryKeyPrefix,
] as const

export const businessesQueryOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    filter: Partial<OmitDeepMessageFields<BusinessFiltersDto>> = {}
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...usersListQueryKeyPrefix, filter],
        queryFn: ({ signal }) => {
            assertNotNullish(clients?.business)

            return clients.business.getBusinesses(
                {
                    deletedItemSelection:
                        filter.deletedItemSelection ??
                        DeletedItemSelection.BOTH,
                    ids: filter.ids ?? [],
                    sorting: filter.sorting ?? [],
                    pagination: filter.pagination,
                    searching: filter.searching ?? [],
                    searchOperator: filter.searchOperator,
                },
                { signal }
            )
        },
    })

export const useBusinesses = (
    filter: Partial<OmitDeepMessageFields<BusinessFiltersDto>> = {}
) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(businessesQueryOptions(clients, filter))
}
